import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'expenses',
  type: 'node--expenses',
  attributes: {
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    gestoria: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'gestoria',
    },
    hacienda: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'hacienda',
    },
    notario: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'notario',
    },
    registro: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'registro',
    },
    seguro: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'seguro',
    },
    timbres: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'timbres',
    },
    tipoHacienda: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'tipo_hacienda',
    },
    varios: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'varios',
    },
  },
  relationships: {},
};
export const ExpensesService = createService(base, configuration, API_CONFIG.API);
export const ExpensesModule = createModule(ExpensesService, true);



// WEBPACK FOOTER //
// ./src/models/expenses.js